import { StyledButton } from '../../Atoms/Button/styles'
import { styled } from '../../Styles/stitches.config'

export const StyledButtonGroup = styled('div', {
    display: 'inline-flex',

    [`& > ${StyledButton}`]: {
        '&:not(:first-of-type)': {
            borderBottomLeftRadius: 0,
            borderTopLeftRadius: 0,
            ml: -1,
        },

        '&:not(:last-of-type)': {
            borderBottomRightRadius: 0,
            borderRightColor: 'transparent',
            borderTopRightRadius: 0,
        },
    },
})
